// Helper function to determine if a piece of content uses the "no-item" paradigm to omit it from multilingual sites.
export default function isNoItem(text) {
    return String(text)
        .toLowerCase()
        .startsWith("[[noitem]]");
}
